import React from "react";
import FlowStepContainer from "./flowStepContainer";
import FlowStepSingleSelect from "./flowStepSingleSelect";

export default function FlowStepBusinessSize({ stepNo, totalSteps, onDataSubmit, forTrial }) {
  const onValueSelected = (value) => {
    onDataSubmit({
      employees: value,
    });
  };

  const options = [
    {
      label: "Just me",
      subline: "1",
      value: "1",
      img: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <circle cx="10" cy="10" r="10" fill="#D6BCF9" />
        </svg>
      ),
    },
    {
      label: "Small",
      subline: "2-4",
      value: "2-5",
      img: (
        <svg xmlns="http://www.w3.org/2000/svg" width="88" height="20" viewBox="0 0 88 20" fill="none">
          <circle cx="78" cy="10" r="10" fill="#D6BCF9" />
          <circle cx="44" cy="10" r="10" fill="#E9DBFC" />
          <circle cx="10" cy="10" r="10" fill="#C098F5" />
        </svg>
      ),
    },
    {
      label: "Medium",
      subline: "5-15",
      value: "6-15",
      img: (
        <svg xmlns="http://www.w3.org/2000/svg" width="104" height="48" viewBox="0 0 104 48" fill="none">
          <circle cx="66" cy="38" r="10" fill="#E9DBFC" />
          <circle cx="10" cy="10" r="10" fill="#E9DBFC" />
          <circle cx="66" cy="10" r="10" fill="#D6BCF9" />
          <circle cx="94" cy="10" r="10" fill="#A171DF" fill-opacity="0.9" />
          <circle cx="38" cy="10" r="10" fill="#C098F5" fill-opacity="0.8" />
          <circle cx="94" cy="38" r="10" fill="#C098F5" fill-opacity="0.8" />
          <circle cx="38" cy="38" r="10" fill="#C098F5" />
          <circle cx="10" cy="38" r="10" fill="#D6BCF9" />
        </svg>
      ),
    },
    {
      label: "Large",
      subline: "16+",
      value: "16+",
      img: (
        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="66" viewBox="0 0 120 66" fill="none">
          <circle cx="78" cy="42" r="6" fill="#E9DBFC" />
          <circle cx="96" cy="6" r="6" fill="#E9DBFC" />
          <circle cx="6" cy="6" r="6" fill="#E9DBFC" />
          <circle cx="24" cy="6" r="6" fill="#D6BCF9" />
          <circle cx="114" cy="24" r="6" fill="#D6BCF9" />
          <circle cx="60" cy="6" r="6" fill="#A171DF" fill-opacity="0.9" />
          <circle cx="114" cy="6" r="6" fill="#A171DF" fill-opacity="0.9" />
          <circle cx="42" cy="6" r="6" fill="#C098F5" fill-opacity="0.8" />
          <circle cx="78" cy="6" r="6" fill="#C098F5" fill-opacity="0.8" />
          <circle cx="42" cy="24" r="6" fill="#C098F5" />
          <circle cx="96" cy="24" r="6" fill="#C098F5" fill-opacity="0.8" />
          <circle cx="6" cy="24" r="6" fill="#C098F5" />
          <circle cx="78" cy="24" r="6" fill="#C098F5" />
          <circle cx="24" cy="24" r="6" fill="#E9DBFC" />
          <circle cx="42" cy="60" r="6" fill="#E9DBFC" />
          <circle cx="96" cy="60" r="6" fill="#E9DBFC" />
          <circle cx="6" cy="42" r="6" fill="#A171DF" fill-opacity="0.9" />
          <circle cx="42" cy="42" r="6" fill="#A171DF" fill-opacity="0.9" />
          <circle cx="96" cy="42" r="6" fill="#D6BCF9" />
          <circle cx="60" cy="24" r="6" fill="#D6BCF9" />
          <circle cx="114" cy="42" r="6" fill="#C098F5" />
          <circle cx="24" cy="42" r="6" fill="#C098F5" fill-opacity="0.8" />
          <circle cx="60" cy="42" r="6" fill="#C098F5" fill-opacity="0.8" />
          <circle cx="60" cy="60" r="6" fill="#D6BCF9" />
          <circle cx="114" cy="60" r="6" fill="#C098F5" fill-opacity="0.8" />
          <circle cx="24" cy="60" r="6" fill="#C098F5" />
          <circle cx="78" cy="60" r="6" fill="#A171DF" fill-opacity="0.9" />
          <circle cx="6" cy="60" r="6" fill="#D6BCF9" />
        </svg>
      ),
    },
  ];

  return (
    <FlowStepContainer
      stepNo={stepNo}
      totalSteps={totalSteps}
      title="How many service providers do you have?"
      subTitle={forTrial ? "We’ll tailor your experience based on the size of your business " : null}
    >
      <FlowStepSingleSelect onValueSelected={onValueSelected} options={options} />
    </FlowStepContainer>
  );
}
